import { render, staticRenderFns } from "./UnitsHolder.vue?vue&type=template&id=5b6b523c"
import script from "./UnitsHolder.vue?vue&type=script&lang=js"
export * from "./UnitsHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports